/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetNursingHomesSummaryQueryResponse,
  GetNursingHomesSummaryQueryParams,
} from '../types/GetNursingHomesSummary'

function getGetNursingHomesSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/nursing_home/summary/` as const }
  return res
}

/**
 * @summary Nursing homes list summary (count of filtered rows)
 * {@link /api/v1/nursing_home/summary/}
 */
export async function getNursingHomesSummary(
  params?: GetNursingHomesSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetNursingHomesSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetNursingHomesSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
